export default "__VITE_ASSET__Poy_STvf__"